import React, { ReactElement } from "react";
import { Badge, BadgeColor, Stack } from "sprint-common-web";

import { RecordTypeBadge } from "../components/RecordTypeBadge";
import { RecordType } from "../types/RecordType";

export const renderAssetInfo = ({
    isTrimmed,
    recordType,
    testId
}: {
    recordType?: RecordType;
    isTrimmed: boolean;
    testId?: string;
}): ReactElement | null => {
    if (!recordType) {
        return null;
    }

    return (
        <Stack style={{ flexDirection: "row", gap: 4 }} data-testId={testId}>
            <RecordTypeBadge value={recordType} />
            {isTrimmed && <Badge color={BadgeColor.Gray} text="Trimmed" />}
        </Stack>
    );
};
